import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
type TextListProps = {
  items?: string[];
  limit?: number;
  textClassName?: string;
};
const TextList = t0 => {
  const $ = _c(4);
  const {
    items: t1,
    limit: t2,
    textClassName: t3
  } = t0;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    const items = t1 === undefined ? [] : t1;
    const limit = t2 === undefined ? 3 : t2;
    const textClassName = t3 === undefined ? "text-body-2 text-primary" : t3;
    const firstPart = items.slice(0, limit);
    const lastPart = items.slice(limit);
    const shouldCut = items.length > limit;
    t4 = shouldCut ? <div className="flex gap-1 justify-between items-center"><p className={cx(textClassName, "flex-1 min-w-0 truncate")}>{firstPart.join(", ")}</p><Tooltip disabled={!lastPart.length} content={lastPart.join(", ")}><div className="flex items-center gap-0.5 shrink-0"><p className={textClassName}>and</p><p className={cx(textClassName, "underline")}>more</p></div></Tooltip></div> : <p className={cx(textClassName)}>{items.join(", ")}</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default TextList;